module.exports = __webpack_public_path__ + "img/icon-download-cloud.ef49387b.svg";